import { useEffect, useState } from "react";
import { api } from "../../../../service/api";
import { MaintenanceAllDTO } from "../../../../dtos/MaintenanceAllDTO";

export function useListMaintenance() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<MaintenanceAllDTO[]>([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get("company/maintenance/car/all");
      setDataList(response.data);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
